import type { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";

import PageLayout from "../components/PageLayout";

import Defi from "../container/pages/defi";
import { PageProvider } from "@providers/page";
import defiJSON from "@files/defi.json";

const DefiPage: NextPage = () => {
  const { pools, allTags } = defiJSON;
  const getHeader = useMemo(() => {
    return (
      <Head>
        <title>Kelp</title>
        <meta name="description" content="Kelp" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="robots" content="index, follow" />
      </Head>
    );
  }, []);

  return (
    <PageProvider value={{ pageData: { allTags, pools } }}>
      {getHeader}

      <PageLayout>
        <Defi />
      </PageLayout>
    </PageProvider>
  );
};

export default DefiPage;
